/* OPS tutorial search: searches titles, chapters, notes and every word Jim says in the videos.
   Ranks tutorials (BM25), forgives typos and producer slang, links each hit to the moment it's said.
   Never comes back empty-handed: queries with nothing to search on ("hi", "but") get a fallback. */
(function () {
  var STOP = new Set(("a an and are as at be been but by can could did do does doing done for from get gets got had has have he " +
    "her here him his how i id ill im ive if in into is it its just lets like me more most my no not now of off ok okay on once " +
    "one only or our out over really right so some such than that thats the their them then there these they this those to too " +
    "up us very was we were well what when where which while who why will with would yeah yes you your youre gonna wanna kinda " +
    "thing things stuff actually basically literally hi hey hello yo sup thanks thank please make makes making made want need " +
    "use using used way ways guys guy video videos tutorial tutorials good nice cool also all any each every much many lot lots " +
    "go going gotta let see look know think say said little bit something anything everything new learn learning help").split(" "));

  // Producer words that mean the same thing. A query word also finds the others in its group (a bit lower).
  var GROUPS = [
    ["kick", "kik", "kic", "kicks", "kickdrum"], ["zaag", "zag", "saag", "zaagkick"], ["screech", "screach", "screeches", "screetch"],
    ["vocal", "vox", "voice", "vocals", "singer", "acapella", "acappella"], ["euphoric", "euphoria", "melodic", "melody"],
    ["rawstyle", "raw", "rawphoric"], ["uptempo", "terror"], ["frenchcore", "french"], ["industrial", "techno"],
    ["midintro", "anticlimax"], ["gated", "gate", "gating"], ["mix", "mixing", "mixdown"],
    ["master", "mastering", "loud", "louder", "loudness", "limiter", "lufs"], ["reverb", "verb", "reeverb"],
    ["distortion", "distort", "dist", "clip", "clipping", "clipper", "saturation", "saturate", "overdrive", "drive", "gclip"],
    ["pitch", "pitching", "tune", "tuning"], ["layer", "layering", "layers"], ["lead", "leads", "supersaw"],
    ["chord", "chords", "harmony", "progression", "theory", "scale"], ["sidechain", "ducking", "pump", "pumping"],
    ["eq", "equalizer", "equaliser"], ["compression", "compressor", "compress", "ott", "multiband", "promb"],
    ["break", "breakdown", "intro", "buildup"], ["drop", "climax"], ["fx", "effects", "effect", "riser", "impact", "kickfx"],
    ["beginner", "beginners", "start", "starter", "noob", "newbie", "basics", "basic", "first"],
    ["serum", "serum2"], ["sylenth", "sylenth1"], ["flstudio", "fl", "fruity"], ["laser", "lazer"], ["psy", "psykick"],
    ["kloenk", "klonk", "pvc"], ["kickroll", "roll"], ["ai", "artificial"], ["acid", "303"],
    ["punch", "tok", "transient", "click"], ["tail", "rumble"], ["bass", "sub"],
    ["template", "flp", "project", "preset", "presets", "download", "freebie"], ["oldschool", "classic"],
    ["subzero", "szp"], ["wavefold", "wavefolding", "folding", "folder", "distructor"], ["noise", "noisy"],
    ["cinematic", "film", "movie"], ["arp", "arpeggio", "arpeggiator"], ["pluck", "plucks"]
  ];
  var PHRASES = [
    [/\bmid[\s-]*intro\b/g, "midintro"], [/\bkick[\s-]*roll\b/g, "kickroll"], [/\bsub[\s-]*zero\b/g, "subzero"],
    [/\bold[\s-]*school\b/g, "oldschool"], [/\bup[\s-]*tempo\b/g, "uptempo"], [/\bfl[\s-]*studio\b/g, "flstudio"],
    [/\bfruity[\s-]*loops\b/g, "flstudio"], [/\bserum[\s-]*2\b/g, "serum2"], [/\bsylenth[\s-]*1\b/g, "sylenth1"],
    [/\bpro[\s-]*mb\b/g, "promb"], [/\bpro[\s-]*q\b/g, "proq"], [/\bpro[\s-]*l\b/g, "prol"], [/\bkick[\s-]*fx\b/g, "kickfx"],
    [/\breverse[\s-]*bass\b/g, "reversebass"], [/\bwave[\s-]*fold(ing|er)?\b/g, "wavefold$1"], [/\bside[\s-]*chain\b/g, "sidechain"],
    [/\bpsy[\s-]*kicks?\b/g, "psykick"], [/\bg[\s-]*clip\b/g, "gclip"], [/\bwhite[\s-]*noise\b/g, "noise"]
  ];

  function norm(s) {
    s = String(s).toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[‘’']/g, "");
    for (var i = 0; i < PHRASES.length; i++) s = s.replace(PHRASES[i][0], PHRASES[i][1]);
    return s;
  }
  function stem(w) {
    if (w.length <= 3) return w;
    if (/ies$/.test(w) && w.length > 4) return w.slice(0, -3) + "y";
    if (/(ch|sh|ss|x|z)es$/.test(w)) return w.slice(0, -2);
    if (/ing$/.test(w) && w.length - 3 >= 4) return w.slice(0, -3);
    if (/s$/.test(w) && !/ss$/.test(w)) return w.slice(0, -1);
    return w;
  }
  function tokens(s) { return norm(s).split(/[^a-z0-9]+/).filter(Boolean).map(stem); }

  var GROUP_OF = {};
  GROUPS.forEach(function (g, gi) { g.forEach(function (w) { GROUP_OF[stem(norm(w))] = gi; }); });

  function distance(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i]; var best = i;
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) cur[j] = Math.min(cur[j], prev[j - 2] + 1);
        if (cur[j] < best) best = cur[j];
      }
      if (best > max) return max + 1;
      prev = cur;
    }
    return prev[b.length];
  }

  var IX = null, loading = null;
  // Field weights: a word in the title counts much more than one said in passing.
  var W = { title: 8, tags: 5, chapters: 3, notes: 2, said: 1 };

  function build(data) {
    var docs = data.docs, N = docs.length, tf = [], len = [], df = {}, chunkToks = [], byDoc = [];
    docs.forEach(function (d, i) {
      tf[i] = {}; len[i] = 0; byDoc[i] = [];
      function add(text, w) { tokens(text).forEach(function (t) { if (STOP.has(t)) return; tf[i][t] = (tf[i][t] || 0) + w; }); }
      add(d.t, W.title); add(d.c + " " + d.g.join(" "), W.tags); add(d.ch.join(" "), W.chapters); add(d.n || "", W.notes);
    });
    data.chunks.forEach(function (c, k) {
      var toks = tokens(c[2]), set = {};
      toks.forEach(function (t) { if (STOP.has(t)) return; set[t] = 1; tf[c[0]][t] = (tf[c[0]][t] || 0) + W.said; });
      len[c[0]] += toks.length; chunkToks[k] = set; byDoc[c[0]].push(k);
    });
    docs.forEach(function (d, i) { for (var t in tf[i]) df[t] = (df[t] || 0) + 1; });
    var avg = len.reduce(function (a, b) { return a + b; }, 0) / N;
    var vocab = Object.keys(df);
    IX = { docs: docs, chunks: data.chunks, tf: tf, len: len, avg: avg, df: df, N: N, vocab: vocab, chunkToks: chunkToks, byDoc: byDoc };
  }

  function load(url) {
    if (IX) return Promise.resolve();
    if (!loading) loading = fetch(url).then(function (r) { return r.json(); }).then(build);
    return loading;
  }

  function idf(t) { var n = IX.df[t] || 0; return Math.log(1 + (IX.N - n + 0.5) / (n + 0.5)); }
  function bm25(t, i) {
    var f = IX.tf[i][t]; if (!f) return 0;
    var k1 = 1.2, b = 0.75;
    return idf(t) * (f * (k1 + 1)) / (f + k1 * (1 - b + b * IX.len[i] / IX.avg));
  }

  // Turn one query word into the index words it should match, with a weight each.
  function resolve(t, isLast) {
    var out = {}, fixed = null;
    if (IX.df[t]) out[t] = 1;
    else {
      if (isLast && t.length >= 3) IX.vocab.filter(function (v) { return v.indexOf(t) === 0; })
        .sort(function (a, b) { return IX.df[b] - IX.df[a]; }).slice(0, 6).forEach(function (v) { out[v] = 0.9; });
      if (!Object.keys(out).length && t.length >= 4) {
        var max = t.length >= 7 ? 2 : 1, near = [];
        IX.vocab.forEach(function (v) { var dd = distance(t, v, max); if (dd <= max) near.push([v, dd]); });
        near.sort(function (a, b) { return a[1] - b[1] || IX.df[b[0]] - IX.df[a[0]]; });
        near.slice(0, 3).forEach(function (n, k) { out[n[0]] = k ? 0.6 : 0.85; });
        if (near.length) fixed = near[0][0];
      }
    }
    var gi = GROUP_OF[t];
    if (gi === undefined && fixed) gi = GROUP_OF[fixed];
    if (gi !== undefined) GROUPS[gi].forEach(function (w) { var s = stem(norm(w)); if (IX.df[s] && !out[s]) out[s] = 0.6; });
    return { words: out, fixed: fixed };
  }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  function snippet(text, match) {
    var words = text.split(/\s+/), first = -1;
    var marks = words.map(function (w) {
      var hit = tokens(w).some(function (t) { return match[t]; });
      if (hit && first < 0) first = 0;
      return hit;
    });
    first = marks.indexOf(true);
    var from = Math.max(0, first - 8), to = Math.min(words.length, from + 22);
    var out = words.slice(from, to).map(function (w, k) { return marks[from + k] ? "<mark>" + esc(w) + "</mark>" : esc(w); }).join(" ");
    return (from > 0 ? "…" : "") + out + (to < words.length ? "…" : "");
  }

  function search(q) {
    var all = tokens(q), terms = all.filter(function (t) { return !STOP.has(t) && (t.length > 1 || /\d/.test(t)); });
    if (!terms.length) return { hits: [], reason: "nothing" };
    var fixes = [], resolved = terms.map(function (t, k) {
      var r = resolve(t, k === terms.length - 1);
      if (r.fixed && r.fixed !== t) fixes.push(r.fixed);
      return r.words;
    }).filter(function (r) { return Object.keys(r).length; });
    if (!resolved.length) return { hits: [], reason: "nomatch" };

    var hits = [];
    for (var i = 0; i < IX.N; i++) {
      var score = 0, covered = 0;
      resolved.forEach(function (words) {
        var best = 0;
        for (var w in words) best = Math.max(best, words[w] * bm25(w, i));
        if (best > 0) covered++;
        score += best;
      });
      if (score <= 0) continue;
      if (covered === resolved.length && resolved.length > 1) score *= 1.4;
      hits.push({ i: i, score: score });
    }
    if (!hits.length) return { hits: [], reason: "nomatch" };
    hits.sort(function (a, b) { return b.score - a.score; });
    // keep it focused: only results that are reasonably close to the best one
    var top = hits[0].score;
    hits = hits.filter(function (h) { return h.score >= top * 0.3; }).slice(0, 24);

    // The moment in the video that matches best, with a short quote.
    var match = {};
    resolved.forEach(function (words) { for (var w in words) match[w] = 1; });
    hits.forEach(function (h) {
      var bestK = -1, bestS = 0;
      IX.byDoc[h.i].forEach(function (k) {
        var s = 0, set = IX.chunkToks[k];
        resolved.forEach(function (words) { var m = 0; for (var w in words) if (set[w]) m = Math.max(m, words[w] * idf(w)); s += m; });
        if (s > bestS) { bestS = s; bestK = k; }
      });
      if (bestK >= 0) { var c = IX.chunks[bestK]; h.t = c[1]; h.quote = snippet(c[2], match); }
      h.doc = IX.docs[h.i];
    });
    return { hits: hits, fixed: fixes.length ? fixes.join(" ") : null };
  }

  window.TutSearch = { load: load, search: search, ready: function () { return !!IX; } };
})();
